import { getInitialPageState } from 'components/Experiences/ExperienceOfferPage/utils'
import experiencePageStateReducer, { ExperienceOfferPageDispatchAction, ExperienceOfferPageState } from 'contexts/Experience/ExperienceOfferPage/experienceOfferPageStateReducer'
import { useAppSelector } from 'hooks/reduxHooks'
import { Dispatch, useMemo, useReducer } from 'react'
import { INITIAL_EXPERIENCE_PAGE_STATE } from 'contexts/Experience/ExperienceOfferPage/experienceOfferPageStateReducer'

type ReturnType = [ExperienceOfferPageState, Dispatch<ExperienceOfferPageDispatchAction>]

function useExperiencePageReducer(experience: App.ExperienceOffer): ReturnType {
  const search = useAppSelector(state => state.router.location.search)
  const [state, dispatch] = useReducer(experiencePageStateReducer, INITIAL_EXPERIENCE_PAGE_STATE, () => getInitialPageState(experience, search))

  return useMemo<ReturnType>(() => {
    return [state, dispatch]
  }, [state, dispatch])
}

export default useExperiencePageReducer
